import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import PropTypes from "prop-types";
import styles from 'views/component/Styles.js';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(styles);

export default function SimpleError(props) {
    const { show, title, onConfirm } = props;
    const classes = useStyles();

    return (
        <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={title}
            onConfirm={onConfirm}
            confirmBtnCssClass={classes.button + " " + classes.success}
            show={show}
        />
    );
}

SimpleError.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string,
    onConfirm: PropTypes.func
};
